import clsx from "clsx";
import React from "react";
import { SvgIcon } from "./SvgIcon";
import styles from "./SpinningLoader.module.scss";

type SpinningLoaderProps = {
  message?: string | null;
  messageDetail?: string | null;
  show: boolean;
  style?: React.CSSProperties;
  className?: string;
  attributes?: React.SVGProps<SVGSVGElement>;
  /**
   * Renders in the normal document flow instead of as a fixed, full-viewport overlay. Use this
   * to embed the spinner inside a container (e.g. a card) rather than dimming the whole page.
   */
  inline?: boolean;
};

export const SpinningLoader: React.FunctionComponent<SpinningLoaderProps> = ({
  message,
  messageDetail,
  show = false,
  style,
  className,
  attributes = { width: "30px", height: "30px", viewBox: "0 0 30 30" },
  inline = false,
}) => {
  return show ? (
    <div
      className={clsx(
        inline ? styles.inlineLoading : styles.loading,
        "d-flex flex-column align-items-center w-100",
        !inline && "position-fixed h-100",
        className,
      )}
      style={style}
    >
      <div
        className={clsx(
          styles.content,
          !inline && styles.contentOverlay,
          "d-flex flex-column position-relative align-items-center w-100",
        )}
      >
        <SvgIcon name="loading-spinner" attributes={attributes} />
        <h4 className="font-size-24 fw-bold">{message}</h4>
        <h5 className="font-size-20 text-dark fw-bold m-0">{messageDetail}</h5>
      </div>
    </div>
  ) : null;
};
